"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRelativeDateFilterOption = exports.isAbsoluteDateFilterOption = exports.isUiRelativeDateFilterForm = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * Type-guard testing whether the provided object is an instance of {@link IUiRelativeDateFilterForm}.
 * @public
 */
exports.isUiRelativeDateFilterForm = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "relativeForm";
};
/**
 * Type-guard testing whether the provided object is an instance of {@link AbsoluteDateFilterOption}.
 * @public
 */
exports.isAbsoluteDateFilterOption = function (obj) {
    return sdk_backend_spi_1.isAbsoluteDateFilterForm(obj) || sdk_backend_spi_1.isAbsoluteDateFilterPreset(obj);
};
/**
 * Type-guard testing whether the provided object is an instance of {@link RelativeDateFilterOption}.
 * @public
 */
exports.isRelativeDateFilterOption = function (obj) {
    return sdk_backend_spi_1.isRelativeDateFilterForm(obj) || sdk_backend_spi_1.isRelativeDateFilterPreset(obj);
};
//# sourceMappingURL=index.js.map